import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth.js";
import { LoginPage } from "./pages/Login.js";
import { HomePage } from "./pages/Home.js";
import { SpotterPage } from "./pages/Spotter.js";
import { AdminEventsPage } from "./pages/AdminEvents.js";
import { AdminEventPage } from "./pages/AdminEvent.js";
import { HistoryPage } from "./pages/History.js";
import { HistoryFightPage } from "./pages/HistoryFight.js";
import { AdminImportPage } from "./pages/AdminImport.js";
import { AdminFightersPage } from "./pages/AdminFighters.js";
import { AdminFighterPage } from "./pages/AdminFighter.js";
import { GfxOutputPage } from "./pages/GfxOutput.js";
import { AdminGfxPage } from "./pages/AdminGfx.js";

function RequireAuth({ role, children }: { role: "spotter" | "admin"; children: JSX.Element }) {
  const auth = useAuth();
  if (auth.loading)
    return <div className="p-8 text-neutral-400">Indlæser…</div>;
  if (!auth.role) return <Navigate to="/login" replace />;
  if (role === "admin" && auth.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/gfx" element={<GfxOutputPage />} />
        <Route path="/gfx/:id" element={<GfxOutputPage />} />
        <Route path="/" element={<RequireAuth role="spotter"><HomePage /></RequireAuth>} />
        <Route path="/spotter" element={<RequireAuth role="spotter"><SpotterPage /></RequireAuth>} />
        <Route path="/admin" element={<RequireAuth role="admin"><AdminEventsPage /></RequireAuth>} />
        <Route path="/admin/events/:id" element={<RequireAuth role="admin"><AdminEventPage /></RequireAuth>} />
        <Route path="/admin/import" element={<RequireAuth role="admin"><AdminImportPage /></RequireAuth>} />
        <Route path="/admin/fighters" element={<RequireAuth role="admin"><AdminFightersPage /></RequireAuth>} />
        <Route path="/admin/fighters/:id" element={<RequireAuth role="admin"><AdminFighterPage /></RequireAuth>} />
        <Route path="/admin/gfx" element={<RequireAuth role="admin"><AdminGfxPage /></RequireAuth>} />
        <Route path="/history" element={<RequireAuth role="spotter"><HistoryPage /></RequireAuth>} />
        <Route path="/history/fights/:id" element={<RequireAuth role="spotter"><HistoryFightPage /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
